import type { ExecutionContext, TenantTermination, TerminationRepository } from "@dker/core";
import { DomainError } from "@dker/core";
import type { DbClientFactory } from "../ports.js";

/**
 * La résiliation de l'entreprise, lue par `my_tenant_termination()` : trois
 * dates et un drapeau, jamais la note du staff (`20260301006000`).
 */
export function createSupabaseTerminationRepository(
  clientFor: DbClientFactory,
): TerminationRepository {
  return {
    async mine(ctx: ExecutionContext): Promise<TenantTermination | null> {
      const { data, error } = await clientFor(ctx).rpc("my_tenant_termination");
      if (error) {
        throw new DomainError("conflict", `Lecture de la résiliation impossible : ${error.message}`, {
          pgCode: error.code,
        });
      }
      const row = (Array.isArray(data) ? data[0] : data) as
        | { effective_on: string; purge_on: string; read_only: boolean }
        | null
        | undefined;
      if (!row) return null;
      return {
        effectiveOn: row.effective_on,
        purgeOn: row.purge_on,
        readOnly: row.read_only === true,
      };
    },
  };
}
